import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environments';
import { endpoints } from '../endpoints';

@Injectable({
    providedIn: 'root'
})
export class EopAssistantService {
    constructor(private http: HttpClient) { }

    getEopAssistant(sectionId: any, subSectionId?: any): Observable<{message: string; data: []}> {
        let url = environment.apiBaseUrl + endpoints.eopAssistant.replace(':section_id', sectionId);

        let params = new HttpParams();
        if (subSectionId) {
          params = params.append('sub_section_id', subSectionId);
          url = url.replace(':sub_section_id', subSectionId);
        } else {
          url = url.replace('?sub_section_id=:sub_section_id', ''); // Clean the URL if no sub_section_id provided
        }

        return this.http.get<{message: string; data: []}>(url).pipe(
            catchError(this.handleError)
        );
    }

    private handleError(error: HttpErrorResponse): Observable<never> {
        let errorMessage = 'An unknown error occurred!';

        if (typeof ErrorEvent !== 'undefined' && error.error instanceof ErrorEvent) {
            errorMessage = `Client-side error: ${error.error.message}`;
        } else {
            errorMessage = `Server returned code: ${error.status}, error message is: ${error.message}`;
        }
        console.error(errorMessage);
        return throwError(() => new Error("Cannot retrieve data from server. Please try again."));
    }
}